import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CreatePayment } from '../models/create-payment.model';
import { SubmitPaymentResponse } from '../models/submit-payment-response.model';
import { SubmitPayment } from '../models/submit-payment.model';
import { GenericBaseService } from './generic-base.service';
import { UrlService } from "./url.service";
import {
  HostedPaymentBank,
  HostedPaymentCountry,
  HostedPaymentRequest,
  HostedPaymentRequestStart,
  HostedPaymentRequestStartResponse
} from '../models/hosted-payment-request.model';

@Injectable({
  providedIn: 'root'
})

export class PaymentService extends GenericBaseService {

  private static readonly paymentSubmittedSuccessfully: string = "Payment is submitted successfully";
  private static readonly paymentCancelled: string = "Payment is cancelled";
  private static readonly paymentErrors: string = "Payment has errors";

  constructor(
    protected httpClient: HttpClient,
    protected toastrService: ToastrService,
    protected url: UrlService
  ) {
    super('Payment', httpClient, toastrService, url);
  }

  getPayment<T>(createPayment: CreatePayment, afterPostCallback?: Function) {
    return this.postNow<T>('/payment', this.getBody(createPayment), afterPostCallback);
  }

  postPayment<T>(createPayment: CreatePayment, afterPostCallback?: Function) {
    return this.postNow<T>('/payment', this.getBody(createPayment), afterPostCallback, null, true, true);
  }

  submitPayment(submitPayment: SubmitPayment, afterPostCallback?: Function) {
    this.post('/payment/submit', this.getBody(submitPayment))
      .subscribe(
        (submitPaymentResponse: SubmitPaymentResponse) => {
          if (afterPostCallback) {
            afterPostCallback(submitPaymentResponse);
          }

          if (submitPaymentResponse.HasError) {
            this.toastrService.error(submitPaymentResponse.ErrorMessage);
          }
        });
  }

  getHostedPaymentRequest(authorizationCode: string, afterGetCallback?: (paymentRequest: HostedPaymentRequest) => void): void {
    this.httpClient.get<HostedPaymentRequest>(
      this.getApiUrl(`/payment-request/hosted/${authorizationCode}`),
      {headers: this.buildHttpHeaders(true)}
    )
      .subscribe((paymentRequest: HostedPaymentRequest) => {
        if (afterGetCallback) {
          afterGetCallback(paymentRequest);
        }
      }, () => {
        if (afterGetCallback) {
          afterGetCallback(null);
        }
      });
  }

  getHostedPaymentCountries(afterGetCallback?: (countries: HostedPaymentCountry[]) => void): void {
    this.getNow<HostedPaymentCountry[]>(
      '/payment-request/hosted/countries',
      null,
      afterGetCallback,
      null,
      true,
      false,
      true
    );
  }

  getHostedPaymentBanks(countryId: string, afterGetCallback?: (banks: HostedPaymentBank[]) => void): void {
    this.getNow<HostedPaymentBank[]>(
      `/payment-request/hosted/countries/${countryId}/banks`,
      null,
      afterGetCallback,
      null,
      true,
      false,
      true
    );
  }

  startHostedPaymentRequest(
    authorizationCode: string,
    model: HostedPaymentRequestStart,
    afterPostCallback?: (response: HostedPaymentRequestStartResponse) => void): void {
    this.httpClient.post<HostedPaymentRequestStartResponse>(
      this.getApiUrl(`/payment-request/hosted/${authorizationCode}/start`),
      this.getBody(model),
      {headers: this.buildHttpHeaders(true)}
    )
      .subscribe((response: HostedPaymentRequestStartResponse) => {
        if (afterPostCallback) {
          afterPostCallback(response);
        }
      }, () => {
        if (afterPostCallback) {
          afterPostCallback(null);
        }
      });
  }
}
